import { iconPlusButton, iconSearchButton } from '../../assets';
import { useTheme } from '../../theme';
import type { SearchToolbarProps } from './types';

export function SearchToolbar(props: SearchToolbarProps) {
  const {
    searchValue,
    onSearchChange,
    searchPlaceholder,
    searchAriaLabel,

    actionButton,
    classNamePrefix = 'search-toolbar',
    dataE2eSearchInput,
    dataE2eActionButton,
  } = props;
  const theme = useTheme();

  const toolbarStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.md,
    marginBottom: theme.spacing.lg,
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  };

  const boxStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'stretch',
    flex: '1 1 280px',
    minWidth: 200,
    maxWidth: 480,
    border: `${theme.shape.borderWidth.thin} solid ${theme.palette.filterBox.border}`,
    borderRadius: theme.shape.borderRadius.md,
    backgroundColor: theme.palette.filterBox.background,
    overflow: 'hidden',
  };

  const searchWrapperStyle: React.CSSProperties = {
    position: 'relative',
    flex: 1,
    minWidth: 0,
    margin: theme.spacing.sm,
    backgroundColor: theme.palette.searchInFilter.background,
    borderRadius: theme.shape.borderRadius.md,
    overflow: 'hidden',
  };

  const searchInputStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    minHeight: 40,
    padding: `${theme.spacing.inputY} ${theme.spacing.md} ${theme.spacing.inputY} 2.5rem`,
    fontSize: theme.typography.fontSize.base,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.searchInFilter.background,
    border: 'none',
    outline: 'none',
    boxSizing: 'border-box',
  };

  const iconSpanStyle: React.CSSProperties = {
    position: 'absolute',
    left: theme.spacing.md,
    top: '50%',
    transform: 'translateY(-50%)',
    color: theme.palette.searchInFilter.icon,
    pointerEvents: 'none',
  };

  const actionButtonStyle: React.CSSProperties = actionButton
    ? {
        fontSize: theme.typography.fontSize.base,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeight.semibold,
        color: actionButton.textColor,
        backgroundColor: actionButton.backgroundColor,
        borderRadius: theme.shape.borderRadius.sm2,
        border: 'none',
        cursor: 'pointer',
        minWidth: 147,
        height: 42,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing.sm,
      }
    : {};

  const searchInputClassName = `${classNamePrefix}-search-input`;
  const btnClassName = `${classNamePrefix}-btn`;

  return (
    <div style={toolbarStyle}>
      <style>{`.${searchInputClassName}::placeholder { color: ${theme.palette.searchInFilter.placeholder}; }`}</style>
      <div style={boxStyle} role="search">
        <div style={searchWrapperStyle}>
          <span style={iconSpanStyle} aria-hidden>
            <img src={iconSearchButton} alt="" width={16} height={16} />
          </span>
          <input
            type="text"
            value={searchValue}
            onChange={e => onSearchChange(e.target.value)}
            placeholder={searchPlaceholder}
            style={searchInputStyle}
            className={searchInputClassName}
            aria-label={searchAriaLabel}
            data-e2e={dataE2eSearchInput}
          />
        </div>
        {/* {showFilterButton && (
          <button
            type="button"
            className={btnClassName}
            style={filterButtonStyle}
            aria-label={filterAriaLabel}
          >
            <img src={iconPersonButton} alt="" width={16} height={16} />
            {filterLabel}
          </button>
        )} */}
      </div>
      {actionButton && (
        <button
          type="button"
          className={btnClassName}
          onClick={actionButton.onClick}
          style={actionButtonStyle}
          aria-label={actionButton.ariaLabel}
          data-e2e={dataE2eActionButton}
        >
          <img src={iconPlusButton} alt="" width={16} height={10} />
          {actionButton.label}
        </button>
      )}
    </div>
  );
}
